import React from 'react';
import { get, find } from 'lodash';

// local dependencies
import { claimToDo as ClaimToDoView } from 'ui/views/widgets/claimToDo';
import * as pageLevelPreloader from 'modules/page-level-preloader';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import * as errorOverlay from 'utils/errorOverlay';
import * as successOverlay from 'utils/successOverlay';
import { GLOBAL_LABELS } from 'constants/common';
import { getLabel } from 'utils/getLabel';
import { ClaimToDoService } from 'services/claimToDo';

// import { resolveSecondaryOptionsResolver } from 'resolvers/resolveSecondaryOptions';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { ClaimToDo } from 'ui/containers/ClaimToDo';
 *
 * // render
 * <ClaimToDo propName='propValue'/>
 */
export class ClaimToDo extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // this.state = this.composeStateFromProps();

        this._bind();

        this.claimToDoService = new ClaimToDoService();
    }

    _bind() {
        this.onFormSubmit = this.onFormSubmit.bind( this );

        // this.composeStateFromProps = this.composeStateFromProps.bind( this );
        // this.handleFormChangeCallback = this.handleFormChangeCallback.bind( this );
    }

    // composeStateFromProps() {
    //     log.debug( 'ClaimToDo.composeStateFromProps()' );

    //     const commonFields = filter( this.props.fields, field => {
    //         return  -1 !== indexOf( this.props.commonFields, field.name );
    //     } );

    //     const primaryTypeField = find( commonFields, function( field ) { return 'primary' === get( field, 'config.fieldType', null ); } );
    //     const secondaryTypeField = find( commonFields, function( field ) { return 'secondary' === get( field, 'config.fieldType', null ); } );

    //     return {
    //         options: get( this.props, 'options', {} ),
    //         fields: commonFields,
    //         values: get( this.props, 'state.values' ),
    //         primaryType: get( this.props, `values.${ primaryTypeField.name }`, undefined ),
    //         secondaryType: get( primaryTypeField, `values.${ secondaryTypeField.name }`, undefined ),
    //         staticFields: []
    //     };
    // }

    // handleFormChangeCallback( { values, field } ) {
    //     log.debug( 'ClaimToDo.handleFormChangeCallback()' );

    //     /*-------------------*/

    //     const primaryTypeField = find( this.props.fields, function( _field ) { return 'primary' === get( _field, 'config.fieldType', null ); } );
    //     const secondaryTypeField = find( this.props.fields, function( _field ) { return 'secondary' === get( _field, 'config.fieldType', null ); } );
    //     const primaryTypeValue = get( values, `${ primaryTypeField.name }`, undefined );

    //     if( ! isEmpty( primaryTypeValue ) && ! isEqual( primaryTypeValue, this.state.primaryType ) ) {

    //         const { updatedOptions } = resolveSecondaryOptionsResolver( {
    //             values,
    //             options: this.props.options,
    //             primaryTypeField,
    //             secondaryTypeField,
    //             fields: this.state.fields
    //         } );

    //         // remove the previously selcted values
    //         const _values = cloneDeep( values );
    //         values[ secondaryTypeField.name ] = '';

    //         this.setState( {
    //             values: _values,
    //             options: updatedOptions,
    //             primaryType: primaryTypeValue,
    //             secondaryType: values[ secondaryTypeField.name ],
    //             fields: filter( this.props.fields, _field => {
    //                 return  -1 !== indexOf( this.props.commonFields, _field.name );
    //             } )
    //         } );

    //     }

    //     if( isEqual( field.name, secondaryTypeField.name ) && ! isEqual( this.state.secondaryType, values[ `${secondaryTypeField.name}` ] ) ) {

    //         // fetch dynamicField object
    //         const dynamicField = find( this.props.dynamicFields, { field: field.name, value: values[ `${secondaryTypeField.name}` ] } );

    //         if( dynamicField && isEqual( dynamicField.value, values[ field.name ] ) ) {

    //             let newFields = [];

    //             // use dynamic fields, if present, otherwise use common fields
    //             if ( has( dynamicField, 'fields' ) ) {
    //                 newFields = filter( this.props.fields, _field => {
    //                     return  -1 !== indexOf( dynamicField.fields, _field.name );
    //                 } );
    //             } else {
    //                 newFields = filter( this.props.fields, _field => {
    //                     return  -1 !== indexOf( this.props.commonFields, _field.name );
    //                 } );
    //             }
                
    //             this.setState( {
    //                 fields: newFields,
    //                 values: values,
    //                 secondaryType: values[ `${secondaryTypeField.name}` ]
    //             } );
    //         }
    //     }

    //     /*-------------------*/

    // }

    /**
     * action executed when user clicks on form submit
     */
    async onFormSubmit ( formData ) {
        log.debug( 'ClaimToDo.onFormSubmit()' );

        const context = get( this.props, 'context', {} );
        const successAction = find( this.props.actions, { name: 'submit' } );

        // close overlay
        this.props.onCancelClick();

        // show page preloader
        pageLevelPreloader.show();

        const { status } = await this.claimToDoService.submitFormData( {
            url: successAction.url,
            data: {
                context,
                data: formData
            }
        } );

        // hide page preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            successOverlay.open( { message: getLabel( GLOBAL_LABELS.DISPLAY_TEXT_DONE_SUCCESSFULLY ), } );

        } else {
            errorOverlay.open();
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <ClaimToDoView
                { ...this.props }
                onFormSubmit={ this.onFormSubmit }

                // { ...this.state }
                // onChangeCallBack={ this.handleFormChangeCallback }
            />
        );
    }
}

// set display name
ClaimToDo.displayName = 'ClaimToDo';

// set default props
ClaimToDo.defaultProps = {};

// prop types
ClaimToDo.propTypes = {};
